import type { AuthTokens } from '@data';
import { handleError, logError, OfficeSingleSignOnError } from '@utils-global';
import { exchangeOBO } from './exchangeOBO';
import { handleSSOErrors } from './handleSSOErrors';
import { loginSSO } from './loginSSO';

type ShowToast = (translationKey: string, options?: unknown) => void;

export const authenticateWithSSO = async (showToast: ShowToast): Promise<AuthTokens | null> => {
  try {
    const ssoToken = await loginSSO();
    const graphToken = await exchangeOBO(ssoToken);

    return { graphToken, idToken: ssoToken };
  } catch (error) {
    if (error instanceof OfficeSingleSignOnError) {
      logError('Single sign-on (SSO) login failed', {
        error,
        serializedError: JSON.stringify(error),
      });
      handleSSOErrors(error, showToast);
      return null;
    }

    handleError(error);
    return null;
  }
};
